import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { ToastProvider } from './components/ui.js';
import { AuthProvider } from './lib/auth.js';
import { PlayerProvider } from './lib/player.js';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The portal is a single-operator tool; refetching on every window focus is noise.
      refetchOnWindowFocus: false,
      // A 401 is terminal — the api client has already cleared the session.
      retry: (failureCount, error) =>
        failureCount < 2 && !(error instanceof Error && error.name === 'ApiError'),
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <PlayerProvider>
              <App />
            </PlayerProvider>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
